import React from 'react';
import { Helmet } from "react-helmet";
import './style.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
// import Modal from 'react-bootstrap/Modal';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import PKButton from "components/Button/Button";
import sanitize from 'sanitize-filename';
import ReactTooltip from 'react-tooltip';
import Footer from '../../../components/Footer/Footer';
import axios from "axios";
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import {
    apiUrl, user_access_level, user_account_level, org_friendly_url, locationSearchAPI, HeaderConfig,user_entity_uuid, myHeaders_Autorized, myHeaders_Auth_With_Cache_Control, user_Status, user_API} from "Api/Api";
import { Redirect, Link } from 'react-router-dom';
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import avatar from 'Assets/avatarnew.svg';
// import FavouriteModal from 'components/FavoriteModal/FavoriteModal';
import FollowControlModalButton from 'components/Modals/FollowControlModalButton';
import TipHistoryModalButton from 'components/Modals/TipHistoryModalButton';
// import AccountPaymentModalButton from 'components/Modals/AccountPaymentModalButton';
import home from 'Assets/home.svg';
import geoLocation from 'utils/geoLocation';
import { local_routes } from 'utils/Routes';
import { stripe_plans } from 'utils/stripe_plans';

import { getKey, saveKey } from 'utils/Helper';

import UserContext from 'store/UserContext';

import { get_user_info } from 'Api/GetUserInfo';

let tempArr = []; let countryArr = []; let cityArrTemp = [];let favTotalItems = [];
class AccountSettings extends React.Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            event_registrant_array: [],
            user_info: {},
            firstCity_uuid: null,
            account_level: "public",
            stripe_plan_text: "",
            stripe_paid_through_time_text: "",
            //emailNotifications: true,
            public_status_bool: true,
            org_data: [],
            has_password: false,
            facebook_displayName: '',
            twitter_displayName: '',
            linkedin_displayName: '',
            google_displayName: '',
            optionsChecked: [],
            value: "",
            //loading: true,
            validatedPassword: false,
            validatedUserInfo: false,
            validatedUserDetails: false,
            validatedOtp: false,
            accountInfoLoader: false,
            accountDesigInfoLoader: false,
            accountPasswordLoader: false,
            accountOtpLoader: false,
            accountResendLoader: false,
            imgLoader: false,
            coverImgLoader:false,
            hidden: true,
            hiddenNew: true,
            hiddenPassword: true,
            emailCheck: null,
            clicked: true,
            clickedNew: true,
            clickedPassword: true,
            oldPassword: null,
            newPassword: '',
            confirmPassword: '',
            showModal: false,
            otp: '',
            redirect: false,
            firstName: '',
            friendly_url:'',
            lastName: '',
            userEmail: '',
            country: '',
            city: '',
            cityArr: [],
            firstCity: '',
            occupation: '',
            employer: '',
            website: '',
            description: '',
            avatar_image_url: null,
            cover_image_url:null,
            InvalidMsg: 0,
            InvalidResendMsg: 0,
            InvalidImageUrl: 0,
            imagePreviewUrl: null,
            coverImagePreviewUrl:null,
            pageLoader: true,
            email_optin: null,
            checkboxValue: "email",
            city_Data: [],
            userLocationData: [],
            //email_optin_status: 2,
            invalidPassword: "",
            categoryItems:['Hobbies & Crafts','Fashion & Beauty','Enterpreneurship'],
            filteredTotalFavItems: [],
            show: false,
            favouritesAvailable: true,
            socialAccountLoader:false,
            validatedSocialAccount:false,
            facebook:'',
            twitter:'',
            linkedin:''
        };
        this.toggleShow = this.toggleShow.bind(this);
        this.toggleShowpassword = this.toggleShowpassword.bind(this);
        this.togglePassword = this.togglePassword.bind(this);
        this.OnClickToCatDetailsFav = this.OnClickToCatDetailsFav.bind(this);
        
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
    }
    // Toogles modal show
    showModal = () => {
        this.setState({ show: true });
    }
    // Toogles modal hide
    hideModal = () => {
        this.setState({ show: false });
    }
    
    findMyLocation = async () => {
        console.log("findMyLocation");
        try {
            let geo_data = await geoLocation(); // ask browser for location
            console.log(geo_data);
            // we got user's lat/lon from browser
            let latitude = geo_data.latitude;
            let longitude = geo_data.longitude;
            
            let tmp_bypass_workspace_api_headers = {...HeaderConfig.headers};
            tmp_bypass_workspace_api_headers['X-PK-Organization'] = "";
        
            let closest_location_res = await axios.get(`${locationSearchAPI}?coordinates_lat=${latitude}&coordinates_lon=${longitude}&radius=20038&limit=1`, {headers:tmp_bypass_workspace_api_headers});
            let closest_location = closest_location_res.data.search_query_results[0].entity_info;
            console.log(closest_location);

            let tmp_city_arr = [];
            if (closest_location.country && closest_location.city_name) {
                tempArr.forEach((item) => {
                    if (closest_location.country === item.country) {
                        tmp_city_arr.push(item.city_name);
                    }
                })
                this.setState({ country: closest_location.country, cityArr: tmp_city_arr.unique().sort(), city: closest_location.city_name });
                //this.setState({country:closest_location.country,city:closest_location.city_name});
            }

        } catch (err) {
          // we did not get user's lat/lon from browser - that is ok
        }
    }
    
    // componentDidMount
    async componentDidMount() {
        // is this a refresh?
        console.log("accountsettings componentDidMount",this.props.location.search);
        if (this.props.location.search === '?refresh') {
          console.log("REFRESH user_info");
          let user_info = await get_user_info();
          this.context.setUserInfo(user_info);
          let user_data = getKey("UserData");
          let updated_user_data = {
            UserMail: null,
            login_Auth_Res: {
              access_token: user_data.login_Auth_Res.access_token,
              expTime: user_data.login_Auth_Res.expTime,
              user_uuid: user_data.login_Auth_Res.user_uuid,
              access_level: user_info.access_level,
              account_level: user_info.account_level || 'normal',
              status_code: user_info.status_code
            }
          };
          saveKey("UserData", JSON.stringify(updated_user_data));    
          window.location.href = window.location.pathname;
        }
      
        if (user_Status !== 1) {
            this.setState({ redirect: true });
            return;
        }
        let new_state = {...this.state};
        
        let cover_image_url;
        let tmp_bypass_workspace_api_headers = {...HeaderConfig.headers};
        tmp_bypass_workspace_api_headers['X-PK-Organization'] = "";
        let event_registrant_params = {
          filter_obj: {
            zoom_registrant_status: {
              exists: true
            },
          },
          sort_obj: {
            start_time: 'asc'
          }
        };
        let tip_user_params = {
          filter_obj: {
            tips: {
              exists: true
            },
          }
        };
        
        let api_promises = [
          axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control),
          axios.get(`${locationSearchAPI}?coordinates_lat=0&coordinates_lon=0&radius=20038`, {headers:tmp_bypass_workspace_api_headers}),
          axios.get(`${user_API}/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control),
          axios.get(`${user_API}/${user_entity_uuid}/categories.audience?filter_obj=${encodeURIComponent('{"favorited_time":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control),
          axios.get(`${user_API}/${user_entity_uuid}/organizations`, myHeaders_Auth_With_Cache_Control),
          axios.get(`${user_API}/${user_entity_uuid}/events.audience`, { params: event_registrant_params, ...myHeaders_Auth_With_Cache_Control }),
        ];
        if (user_account_level === 'private' || user_access_level === 'admin') {
          api_promises.push(axios.get(`${user_API}/${user_entity_uuid}/audience`, { params: tip_user_params, ...myHeaders_Auth_With_Cache_Control }));
        }
        /*
        let [userDataRes, locationCityRes, locationDataRes,categoriesRes,organizations_response, event_registrant_response, tips_response] = await Promise.all([
            axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control),
            axios.get(`${locationSearchAPI}?coordinates_lat=0&coordinates_lon=0&radius=20038`, {headers:tmp_bypass_workspace_api_headers}),
            axios.get(`${user_API}/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control),
            axios.get(`${user_API}/${user_entity_uuid}/categories.audience?filter_obj=${encodeURIComponent('{"favorited_time":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control),
            axios.get(`${user_API}/${user_entity_uuid}/organizations`, myHeaders_Auth_With_Cache_Control),
            axios.get(`${user_API}/${user_entity_uuid}/events.audience`, { params: event_registrant_params, ...myHeaders_Auth_With_Cache_Control }),
            axios.get(`${user_API}/${user_entity_uuid}/users.audience`, { params: tip_user_params, ...myHeaders_Auth_With_Cache_Control }),
        ]);
        */
        
        let [userDataRes, locationCityRes, locationDataRes,categoriesRes,organizations_response, event_registrant_response, tips_response] = await Promise.all(api_promises);
        
        new_state.stripe_account_tip_payout_total = 0;
        
        if (tips_response && tips_response.data && tips_response.data.length > 0) {
          // add 'em up!
          tips_response.data.forEach( element => {
            element.xref_data.tips.forEach( element2 => {
              new_state.stripe_account_tip_payout_total += element2.tip_amount;
            });
          });
        }
        
        if (event_registrant_response.data && event_registrant_response.data.length > 0) {
          new_state.event_registrant_array = event_registrant_response.data;
        }
           
        if (organizations_response.data && organizations_response.data.length > 0) {
            new_state.org_data = organizations_response.data;
        }
        
        if (userDataRes.data) {
            new_state.user_info = userDataRes.data;
            if (!new_state.user_info.email_notifications_status) {
                new_state.user_info.email_notifications_status = 'all';
            }
            if (!new_state.user_info.email_scheduled_optin_status) {
                new_state.user_info.email_scheduled_optin_status = 'all';
            }
            if (!new_state.user_info.email_optin_status) {
                new_state.user_info.email_optin_status = 2;
            }
            if (userDataRes.data.cover_image_url) {
                let url = userDataRes.data.cover_image_url;
                let array = url.split("/");
                cover_image_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_1300x360/${array[5]}` 
            }
            if (userDataRes.data.avatar_image_url) {
                let url = userDataRes.data.avatar_image_url;
                let array = url.split("/");
                userDataRes.data.avatar_image_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}` 
            }
            let public_status_bool = true;
            if (userDataRes.data.public_status && userDataRes.data.public_status === 'private') {
                public_status_bool = false;
            }
            
            /*
            let emailNotifications = true;
            let statusChangeChecked = userDataRes.data.email_optin_status;
            if (statusChangeChecked === 1 || statusChangeChecked === 3) {
                emailNotifications = false;
            }
            */
            
            let stripe_plan_text = "";
            let stripe_subscription_type_text = "";
            if (userDataRes.data.stripe_plan_id) {
                if (stripe_plans[process.env.REACT_APP_PK_ENV] && stripe_plans[process.env.REACT_APP_PK_ENV][userDataRes.data.stripe_plan_id]) {
                    stripe_plan_text = stripe_plans[process.env.REACT_APP_PK_ENV][userDataRes.data.stripe_plan_id].nickname;
                    if (stripe_plans[process.env.REACT_APP_PK_ENV][userDataRes.data.stripe_plan_id].interval) {
                      stripe_plan_text += ' - billed '+stripe_plans[process.env.REACT_APP_PK_ENV][userDataRes.data.stripe_plan_id].interval+'ly';
                    }
                    if (stripe_plans[process.env.REACT_APP_PK_ENV][userDataRes.data.stripe_plan_id].type === 'pro') {
                        stripe_subscription_type_text = 'PRO';
                    } else if (stripe_plans[process.env.REACT_APP_PK_ENV][userDataRes.data.stripe_plan_id].type === 'team') {
                        stripe_subscription_type_text = 'Team Billing';
                    }
                }
            }
            let stripe_paid_through_time_text = "";
            if (userDataRes.data.stripe_paid_through_time) {
                let tmp_date = new Date(userDataRes.data.stripe_paid_through_time * 1000);
                if (userDataRes.data.stripe_subscription_status) {
                    stripe_paid_through_time_text = "Subscribed; Current Period ends "+tmp_date.toLocaleDateString(tmp_date);
                } else {
                    stripe_paid_through_time_text = "Subscription canceled; Valid until "+tmp_date.toLocaleDateString(tmp_date);
                }
            }
            let stripe_account_tip_ready_text = "Setup incomplete - please click 'Manage Tip Account' to complete setup and receive payouts";
            if (userDataRes.data.stripe_account_id && userDataRes.data.stripe_account_tip_ready) {
              stripe_account_tip_ready_text = "Setup complete! You can change your payout settings by clicking 'Manage Tip Account'";
            }
 
            new_state = {
                ...new_state,
                user_info: userDataRes.data,
                account_level: userDataRes.data.account_level || 'normal',
                stripe_customer_id: userDataRes.data.stripe_customer_id || '',
                stripe_subscription_type_text,
                stripe_account_tip_ready_text,
                stripe_plan_text,
                stripe_paid_through_time_text,
                //emailNotifications,
                has_password: userDataRes.data.has_password,
                facebook_displayName: userDataRes.data.facebook_displayName,
                twitter_displayName: userDataRes.data.twitter_displayName,
                linkedin_displayName: userDataRes.data.linkedin_displayName,
                google_displayName: userDataRes.data.google_displayName,
                firstName: userDataRes.data.firstname,
                friendly_url:userDataRes.data.friendly_url,
                lastName: userDataRes.data.lastname,
                userEmail: userDataRes.data.email,
                occupation: userDataRes.data.occupation,
                employer: userDataRes.data.employer,
                website: userDataRes.data.website_url,
                description: userDataRes.data['description'],
                avatar_image_url: userDataRes.data.avatar_image_url,
                //email_optin_status: userDataRes.data.email_optin_status,
                cover_image_url:cover_image_url,
                facebook:userDataRes.data.facebook_handle,
                twitter:userDataRes.data.twitter_handle,
                linkedin:userDataRes.data.linkedin_handle,
                public_status_bool
            }
        }    
        //this.setState({ pageLoader: false });
            
        if (locationCityRes.data) {
            let countryArrTemp = [];
            let minified_res = locationCityRes.data.search_query_results;
            // Creating Arrays for all response and all countries list
            minified_res.forEach(function (element) {
                tempArr.push(element.entity_info);
                countryArrTemp.push(element.entity_info.country)
                cityArrTemp.push(element.entity_info.city_name.trim())
            });
            // Creating unique countries from the list and pushing to countryArr
            let countryList = countryArrTemp.unique().sort();
            countryArr = [];
            countryList.forEach((countryItem) => {
                countryArr.push(countryItem)
            })
            
            new_state.city_Data = tempArr;
            
            //this.setState({ city_Data: tempArr, loading: false });
        }

        if (locationDataRes.data) {
            let cityArr = [];
            if (locationDataRes.data.length > 0) {

                tempArr.forEach((item) => {
                    if (locationDataRes.data[0].country === item.country) {
                        cityArr.push(item.city_name)
                    }
                })
                new_state = {
                    ...new_state,
                    cityArr: cityArr.unique().sort(),
                    country: locationDataRes.data[0].country,
                    city: locationDataRes.data[0].city_name.trim(),
                    firstCity: locationDataRes.data[0].city_name.trim(),
                    firstCity_uuid: locationDataRes.data[0].entity_uuid,
                    userLocationData: locationDataRes.data[0]
                }

                //this.setState({ cityArr: cityArr.unique().sort(), country: locationDataRes.data[0].country, city: locationDataRes.data[0].city_name, firstCity: locationDataRes.data[0].city_name, userLocationData: locationDataRes.data[0] });
                
            } else {
                
                tempArr.forEach((item) => {
                    if (countryArr[0] === item.country) {
                        cityArr.push(item.city_name);
                    }
                })
                new_state = {
                    ...new_state,
                    cityArr: cityArr,
                    firstCity: cityArr[0],
                    userLocationData: countryArr[0],
                    city: cityArr[0]
                }
            }
        }
        
        if (categoriesRes.data.length !== 0) {
            let filteredTotalFavItems=[]
            categoriesRes.data.forEach((item) => {
                filteredTotalFavItems.push(item)
            })
            new_state.filteredTotalFavItems = filteredTotalFavItems;
            //this.setState({filteredTotalFavItems:filteredTotalFavItems})
        }
        new_state.pageLoader = false;

        this.setState(new_state);
            
            
                /*
                if (userDataRes.data) {
                    if (userDataRes.data.cover_image_url !== undefined && !null) {
                        let url = userDataRes.data.cover_image_url;
                        let array = url.split("/");
                        cover_image_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_1300x360/${array[5]}` 
                      }
                    if (userDataRes.data.avatar_image_url !== undefined && !null) {
                        let url = userDataRes.data.avatar_image_url;
                        let array = url.split("/");
                        userDataRes.data.avatar_image_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/noborder_circle_125x125/${array[5]}` 
                      }
                      
                    this.setState({
                        has_password: userDataRes.data.has_password,
                        facebook_displayName: userDataRes.data.facebook_displayName,
                        twitter_displayName: userDataRes.data.twitter_displayName,
                        firstName: userDataRes.data.firstname,
                        friendly_url:userDataRes.data.friendly_url,
                        lastName: userDataRes.data.lastname,
                        userEmail: userDataRes.data.email,
                        occupation: userDataRes.data.occupation,
                        employer: userDataRes.data.employer,
                        website: userDataRes.data.website_url,
                        description: userDataRes.data.description,
                        avatar_image_url: userDataRes.data.avatar_image_url,
                        email_optin_status: userDataRes.data.email_optin_status,
                        cover_image_url:cover_image_url,
                        facebook:userDataRes.data.facebook_handle,
                        twitter:userDataRes.data.twitter_handle,
                        linkedin:userDataRes.data.linkedin_handle
                    })
                    let statusChangeChecked = userDataRes.data.email_optin_status;
                    statusChangeChecked === 1 || statusChangeChecked === 3 ? this.setState({ emailNotifications: false }) : this.setState({ emailNotifications: true })
                    this.setState({ pageLoader: false, })
                }
                */
                /*
                if (locationCityRes.data) {
                    let countryArrTemp = [];
                    let minified_res = locationCityRes.data.search_query_results;
                    // Creating Arrays for all response and all countries list
                    minified_res.forEach(function (element) {
                        tempArr.push(element.entity_info);
                        countryArrTemp.push(element.entity_info.country)
                        cityArrTemp.push(element.entity_info.city_name)
                    });
                    // Creating unique countries from the list and pushing to countryArr
                    var countryList = countryArrTemp.unique().sort();
                    countryList.forEach((countryItem) => {
                        countryArr.push(countryItem)
                    })
                    // Getting cities from countries list

                    this.setState({ city_Data: tempArr, loading: false });
                }
                */
                
                /*
                if (locationDataRes.data) {
                    let cityArr = [];
                    if (locationDataRes.data.length > 0) {

                        tempArr.forEach((item) => {
                            if (locationDataRes.data[0].country === item.country) {
                                cityArr.push(item.city_name)
                            }
                        })
                        this.setState({ cityArr: cityArr.unique().sort(), country: locationDataRes.data[0].country, city: locationDataRes.data[0].city_name, firstCity: locationDataRes.data[0].city_name, userLocationData: locationDataRes.data[0] });
                        
                    } else {
                        
                        tempArr.forEach((item) => {
                            if (countryArr[0] === item.country) {
                                cityArr.push(item.city_name)
                                this.setState({
                                    cityArr: cityArr,
                                    firstCity: cityArr[0],
                                    userLocationData: countryArr[0],
                                    city: cityArr[0]
                                });
                            }
                        })
                        
                    }

                }
                */
                // favorite Modal
            /*
            if (categoriesRes.data.length !== 0) {
                let filteredTotalFavItems=[]
                categoriesRes.data.forEach((item) => {
                filteredTotalFavItems.push(item)
                this.setState({filteredTotalFavItems:filteredTotalFavItems})
                })
            }
            */
            
    }

    countryCityFilter = event => {
        console.log("countryCityFilter");
        let cityArr = [];
        if (event.target.id === "userCountry") {
            this.setState({ country: event.target.value });
            let countryChangeItem = event.target.value;
            tempArr.forEach((item) => {
                if (countryChangeItem === item.country) {
                    cityArr.push(item.city_name)
                    this.setState({ cityArr: cityArr.unique().sort(), city: item.city_name });
                }
            })
        }
        else if (event.target.id === "userCity") {
            this.setState({ city: event.target.value });
        }
    }
    // Modal functionality
    close = () => {
        this.setState({ showModal: false });
    }

    open = () => {
        this.setState({ showModal: true });
    }
     // Navigates to category detail page
     OnClickToCatDetailsFav(data) {
        if (!this.workspace_base_url) {
            this.props.history.push({
                pathname: `${local_routes.categories}/${data.friendly_url}`,
                state: { entityData: data, status: true, userFavCategories: favTotalItems, checked: true }
            })
        }
    }
    /*
    categoryLink=()=>{
        window.location.href = `${window.origin}/accountsettings`
    }
    */
    // input maximum length
    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    // password validation
    myPasswordChangeHandler = event => {
        if (event.target.id === "oldPasswordName") {
            this.setState({ oldPassword: event.target.value });
        } else if (event.target.id === "newPasswordName") {
            this.setState({ newPassword: event.target.value });
        }
        else if (event.target.id === "confirmPasswordName") {
            this.setState({ confirmPassword: event.target.value });
        }
    };
    // password validation submit
    handleSubmitData = event => {
        const { newPassword, confirmPassword } = this.state;
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if (form.checkValidity() !== false) {
            event.preventDefault();
            if (newPassword === confirmPassword) {
                const { oldPassword, newPassword } = this.state;
                this.setState({ accountPasswordLoader: true })
                let passwordData = { "new_password": newPassword };
                if (oldPassword) {
                    passwordData.old_password = oldPassword;
                }
                axios.post(`${user_API}/${user_entity_uuid}/resetPassword`, JSON.stringify(passwordData), myHeaders_Autorized)
                    .then((response) => {
                        if (response.data.message && response.data.message === 'password reset successful') {
                            this.setState({ accountPasswordLoader: false, InvalidMsg: 1 });
                        } else {
                            this.setState({ accountPasswordLoader: false, InvalidMsg: 2 });
                        }
                            //window.location.href = `${origin}/accountsettings`;
                    })
                    .catch(() => {
                        this.setState({ accountPasswordLoader: false, InvalidMsg: 2, })
                    });
            }
            else {
                this.setState({ invalidPassword: 'Password not Matched' })
            }
        }
        this.setState({ validatedPassword: true })
    };
    // Message for Password
    messagePassword = () => {
        return (
            <div style={{ display: this.state.InvalidMsg === 0 ? "none" : null }} className="Invalid-section">
                <span className="Invalid-Msg">Invalid Username/Password</span>
            </div>
        )
    }
    // Message for Update Password
    messageUpdatePassword = () => {
        const { InvalidMsg } = this.state;
        return (
            <div style={{ display: this.state.InvalidMsg === 0 ? "none" : null }} className="Invalid-section resend-msg">
                {
                    InvalidMsg === 1 ?
                        <span className="Valid-Msg">Password Updated Successfully</span>
                        :
                        InvalidMsg === 2 ?
                            <span className="Invalid-Msg">Password Not Updated Try Again</span>
                            : null
                }
            </div>
        )
    }

    // Password Hide and Show
    toggleShow() {
        this.setState({ hidden: !this.state.hidden, clicked: !this.state.clicked });
    }
    toggleShowpassword() {
        this.setState({ hiddenNew: !this.state.hiddenNew, clickedNew: !this.state.clickedNew });
    }
    togglePassword() {
        this.setState({ hiddenPassword: !this.state.hiddenPassword, clickedPassword: !this.state.clickedPassword });
    }

    // UserData validation Start 
    myUserInformationHandler = event => {
        if (event.target.id === "firstName") {
            this.setState({ firstName: event.target.value });
        }
        else if (event.target.id === "lastName") {
            this.setState({ lastName: event.target.value });
        }
        else if (event.target.id === "friendly_url") {
            this.setState({ friendly_url: event.target.value.toLowerCase().replace(/ /g, "-") });
        }
        else if (event.target.id === "userEmail") {
            this.setState({ userEmail: event.target.value });
        }
        else if (event.target.id === "userCountry") {
            this.setState({ country: event.target.value });
        }
        else if (event.target.id === "userCity") {
            this.setState({ city: event.target.value });
        }
    }

    handleSubmitUserData = event => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if (form.checkValidity() !== false) {
            event.preventDefault();
            this.setState({ accountInfoLoader: true })
            const { city_Data } = this.state;
            let cityTempArr = []; let CityArrSubmitTemp = []; 
            // let firstCityDel;
            const { firstName, friendly_url,lastName, userEmail, city, firstCity } = this.state;
            // For changing City
            //console.log("CITY",city);
            city_Data.forEach(function (item) {
                //console.log("TEST",item.city_name);
                if (item.city_name.trim() === city.trim()) {
                    cityTempArr.push(item);
                }
            });
            CityArrSubmitTemp = [
                {
                    xref_data: { resident_integer: 1 },
                    entity_uuid: cityTempArr[0].entity_uuid
                }
            ];
            // For removing existing city when user changed to another city
            if (this.state.firstCity_uuid && this.state.firstCity_uuid !== cityTempArr[0].entity_uuid) {
                CityArrSubmitTemp.push(
                    {
                        xref_data: { resident_integer: -1 },
                        entity_uuid: this.state.firstCity_uuid
                    }
                );
            }
            /*
            firstCityDel = city !== firstCity ? firstCity : null;
            if (firstCityDel !== null) {
                this.state.city_Data.forEach(function (item) {
                    if (item.city_name === firstCityDel) {
                        CityArrSubmitTemp.push(
                            {
                                xref_data: { resident_integer: -1 },
                                entity_uuid: item.entity_uuid
                            }
                        )
                        //delCityArr.push(item);
                    }
                });
            }
            */

            // Complete data for user to update
            let patchUserData = {
                "firstname": firstName,
                "friendly_url": friendly_url,
                "lastname": lastName,
                "email": userEmail,
                "locations.audience": CityArrSubmitTemp
            }

            //if (firstCityDel !== null) {
            //    let deleteCity = delCityArr[0].entity_uuid
                // user_API to delete unselected Cities
            //    axios.delete(`${user_API}/${user_entity_uuid}/locations.audience/${deleteCity}`, myHeaders_Autorized, {})
            //}
            axios
                .patch(`${user_API}/${user_entity_uuid}`, patchUserData, myHeaders_Autorized)
                .then(() => {
                    this.setState({ accountInfoLoader: false })
                    //axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
                    //axios.get(`${user_API}/${user_entity_uuid}/locations.audience?filter[resident_integer][gte]=1`, myHeaders_Auth_With_Cache_Control)
                    
                    window.location.reload();
                    //window.location.href = `${origin}/accountsettings`;
                })
                .catch(() => {
                    this.setState({ accountInfoLoader: false })
                });
        }
        this.setState({ validatedUserInfo: true })
    };
    // UserData validation End

    // UserDesignation Data Api
    myUserDataChangeHandler = event => {
        if (event.target.id === "occupation") {
            this.setState({ occupation: event.target.value });
        }
        else if (event.target.id === "employer") {
            this.setState({ employer: event.target.value });
        }
        else if (event.target.id === "userUrl") {
            this.setState({ website: event.target.value });
        }
        else if (event.target.id === "description") {
            this.setState({ description: event.target.value });
        }
        /*
        else if (event.target.id === "checkbox") {
            this.setState({ email_optin_status: event.target.value });
        }
        */
    };

    handleSubmitUserDesignationData = async (event) => {
        event.preventDefault();
        this.setState({ accountDesigInfoLoader: true })
        //const { occupation, employer, website, description, email_optin_status, public_status_bool } = this.state;
        const { occupation, employer, website, description, public_status_bool } = this.state;
        let public_status_string = "public";
        if (!public_status_bool) {
            public_status_string = "private";
        }
        let patchUserProfileData = {
            "occupation": occupation,
            "employer": employer,
            "website_url": website,
            "description": description,
            //"email_optin_status": email_optin_status,
            email_optin_status: this.state.user_info.email_optin_status,
            email_notifications_status: this.state.user_info.email_notifications_status,
            email_scheduled_optin_status: this.state.user_info.email_scheduled_optin_status,
            public_status: public_status_string
        }

        await axios.patch(`${user_API}/${user_entity_uuid}`, patchUserProfileData, myHeaders_Autorized);
        
        // now bust cache
        await Promise.all([
            axios.get(`${user_API}/${this.state.friendly_url}`, myHeaders_Auth_With_Cache_Control),
            axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
        ]);

        //this.setState({ accountDesigInfoLoader: false })
        //this.setState({ validatedUserDetails: true })
        
        window.location.reload();
        //window.location.href = `${origin}/accountsettings`;
        
        //this.props.history.push(`${origin}/accountsettings`);
        
    };
    // UserDesignation Data Api End
    socialAccountHandler=(event)=>{
        if (event.target.id === "facebook_handle") {
            this.setState({ facebook: event.target.value });
        }
        else if (event.target.id === "twitter_handle") {
            this.setState({ twitter: event.target.value });
        }
        else if (event.target.id === "linkedin_handle") {
            this.setState({ linkedin: event.target.value });
        }
    }
    handleSubmitSocialAccount=(event)=>{
        event.preventDefault();
        this.setState({ socialAccountLoader: true })
        const { facebook, twitter, linkedin } = this.state;
        let patchSocialAccountData = {
            "facebook_handle": facebook,
            "twitter_handle": twitter,
            "linkedin_handle": linkedin
        }
        if (facebook !== undefined && facebook !== null) {
            axios.patch(`${user_API}/${user_entity_uuid}`, patchSocialAccountData, myHeaders_Autorized)
            .then(() => {
                //axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
                this.setState({ socialAccountLoader: false })
                window.location.reload();
                //window.location.href = `${origin}/accountsettings`;
            })
            .catch(() => {
                this.setState({ socialAccountLoader: false })
            });
        }
        if (twitter !== undefined && twitter !== null) {
            axios.patch(`${user_API}/${user_entity_uuid}`, patchSocialAccountData, myHeaders_Autorized)
            .then(() => {
                //axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
                this.setState({ socialAccountLoader: false })
                window.location.reload();
                //window.location.href = `${origin}/accountsettings`;
            })
            .catch(() => {
                this.setState({ socialAccountLoader: false })
            });
        }
        if (linkedin !== undefined && linkedin !== null) {
            axios.patch(`${user_API}/${user_entity_uuid}`, patchSocialAccountData, myHeaders_Autorized)
            .then(() => {
                //axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
                this.setState({ socialAccountLoader: false })
                window.location.reload();
                //window.location.href = `${origin}/accountsettings`;
            })
            .catch(() => {
                this.setState({ socialAccountLoader: false })
            });
        }
        this.setState({ validatedSocialAccount: true })
    }

    // Checkboxes Checked halders
    handlePublicStatusChange = (e) => {
        this.setState({ public_status_bool: e.target.checked });
        //let statusChangedEmailNotif = e.target.checked === true ? 2 : 3;
        //this.setState({ email_optin_status: statusChangedEmailNotif })
    }


    // Checkboxes Checked halders
    handleChange = (e) => {
        console.log("Account Settings handleChange",e.target.id);
        if (e.target.id === 'email_notifications_status') {
            this.setState({
                user_info: {
                    ...this.state.user_info,
                    email_notifications_status: this.state.user_info.email_notifications_status === 'all' ? 'none' : 'all'
                }
            });
        } else if (e.target.id === 'email_scheduled_optin_status') {
            this.setState({
                user_info: {
                    ...this.state.user_info,
                    email_scheduled_optin_status: this.state.user_info.email_scheduled_optin_status === 'all' ? 'none' : 'all'
                }
            });
        } else if (e.target.id === 'email_optin_status') {
            // if changed, also change email_scheduled_optin_status
            this.setState({
                user_info: {
                    ...this.state.user_info,
                    email_optin_status: this.state.user_info.email_optin_status === 2 ? 3 : 2,
                    email_scheduled_optin_status: this.state.user_info.email_optin_status === 2 ? 'none' : 'all'
                }
            });
            
            /*
            this.setState({ emailNotifications: e.target.checked });
            let statusChangedEmailNotif = e.target.checked === true ? 2 : 3;
            this.setState({ email_optin_status: statusChangedEmailNotif })
            */
        }
    }


    // Change Avatar method
    onChangeFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let files = event.target.files;
        var index;
        for (index = 0; index < files.length; index++) {
            var file = files[index];
            this.handleLoadImage(file);
        }
        this.setState({ file }); /// if you want to upload later
    }

    // Method to handle changed avatar
    async handleLoadImage(file) {
        this.setState({ imgLoader: true })
        var pictures = [];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState(() => ({
                    imagePreviewUrl: reader.result,
                }));
                pictures.push({ 'image': file, 'imagePreviewUrl': reader.result });
            };
            reader.readAsDataURL(file);

            let profilePicPromise;
            // getting array buffer in profilePicPromise
            profilePicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = () => resolve(reader.result);
            });
            // Calling API's user_API to get getUploadSignedUrl first
            
            let params = {
                asset_type: 'avatar_image',
                filename: sanitize(file.name).replace(/&\s/g, '_').toLowerCase()
            }
            
            let response = await axios.post(`${user_API}/${user_entity_uuid}/getUploadSignedUrl`, {}, { params, ...myHeaders_Autorized});

            const config = {
                headers: { "Content-Type": response.data.content_type }
            };
            let uploadUrl = response.data.upload_url;
            
            try {
                let value = await profilePicPromise;
                await axios.put(uploadUrl, value, config);
                this.setState({ imgLoader: false, InvalidImageUrl: 0 });
            } catch (err) {
                this.setState({ imgLoader: false, InvalidImageUrl: 1 });
            }

            await Promise.all([
                axios.get(`${user_API}/${this.state.friendly_url}`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
            ]);
            
            /*
            // profilePicPromise then fucntion to get Array buffer to put Axios Call
            
            let self = this;
            axios.post(`${user_API}/${user_entity_uuid}/getUploadSignedUrl`, {}, { params, ...myHeaders_Autorized})
                .then((response) => {
                    axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control); // bust cache
                    const config = {
                        headers: { "Content-Type": response.data.content_type }
                    };
                    let uploadUrl = response.data.upload_url;
                    // profilePicPromise then fucntion to get Array buffer to put Axios Call
                    let self = this;
                    profilePicPromise.then(function (value) {
                        // Calling PUT  to upload Image Array buffer
                        axios
                            .put(uploadUrl, value, config)
                            .then(() => {
                                self.setState({ imgLoader: false, InvalidImageUrl: 0 })
                            })
                            .catch(() => {
                                self.setState({ imgLoader: false, InvalidImageUrl: 1 })
                            });
                    })
                    self.setState({ imgLoader: false })
                })
                .catch(() => {
                });
            */
            this.context.setUserInfo(await get_user_info());
        }
    }
     // Change Cover Image method
     onChangeCoverFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let files = event.target.files;
        var index;
        for (index = 0; index < files.length; index++) {
            var item = files[index];
            this.handleCoverLoadImage(item);
        }
        this.setState({ item }); 
    }
    // Cover image method
    async handleCoverLoadImage(item) {
        this.setState({ coverImgLoader: true })
        var pictures = [];
        if (item) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState(() => ({
                    coverImagePreviewUrl: reader.result,
                }));
                pictures.push({ 'image': item, 'coverImagePreviewUrl': reader.result });
            };
            reader.readAsDataURL(item);

            let coverPicPromise;
            // getting array buffer in profilePicPromise
            coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(item);
                reader.onload = () => resolve(reader.result);
            });
            // this.setState({ imgLoader: false })
            // Calling API's user_API to get getUploadSignedUrl first
            let params = {
                asset_type: 'cover_image',
                filename: sanitize(item.name).replace(/&\s/g, '_').toLowerCase()
            }

            let response = await axios.post(`${user_API}/${user_entity_uuid}/getUploadSignedUrl`, {}, { params, ...myHeaders_Autorized});

            const config = {
                headers: { "Content-Type": response.data.content_type }
            };
            let uploadUrl = response.data.upload_url;
            
            try {
                let value = await coverPicPromise;
                await axios.put(uploadUrl, value, config);
                this.setState({ coverImgLoader: false, InvalidImageUrl: 0 });
            } catch (err) {
                this.setState({ coverImgLoader: false, InvalidImageUrl: 1 });
            }

            await Promise.all([
                axios.get(`${user_API}/${this.state.friendly_url}`, myHeaders_Auth_With_Cache_Control),
                axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
            ]);


            
            
            /*
            axios.post(`${user_API}/${user_entity_uuid}/getUploadSignedUrl`, {}, { params, ...myHeaders_Autorized})
                .then((response) => {
                    axios.get(`${user_API}/${user_entity_uuid}`, myHeaders_Auth_With_Cache_Control)
                    const config = {
                        headers: { "Content-Type": response.data.content_type }
                    };
                    let uploadUrl = response.data.upload_url;
                    // coverPicPromise then fucntion to get Array buffer to put Axios Call
                    let self = this;
                    coverPicPromise.then(function (value) {
                        // Calling PUT  to upload Image Array buffer
                        axios
                            .put(uploadUrl, value, config)
                            .then(() => {
                                self.setState({ coverImgLoader: false, InvalidImageUrl: 0 })
                            })
                            .catch(() => {
                                self.setState({ coverImgLoader: false, InvalidImageUrl: 1 })
                            });
                    })
                    self.setState({ coverImgLoader: false })
                })
                .catch(() => {
                });
                
            */
        }
    }

    manageStripeTipAccountClick = async () => {
        this.setState({
            pageLoader: true
        });
        
        let post_obj = {
            return_url: window.location.href+'?refresh',
            refresh_url: window.location.href+'?refresh'
        }
        
        let account_portal_url_response = await axios.post(`${apiUrl}users/${this.context.user_info.entity_uuid}/getStripeAccountLinkUrl`, post_obj);
        
        if (account_portal_url_response.data.account_link_url) {
            window.location.href = account_portal_url_response.data.account_link_url;
            return;
        } else {
            console.error("ERROR - could not get account portal url");
        }
        
        this.setState({
            pageLoader: false
        });
    }

    manageAccountSubscriptionClick = async () => {
        this.setState({
            pageLoader: true
        });
        
        let params = {
            return_url: window.location.href+'?refresh'
        }
        
        let billing_portal_url_response = await axios.post(`${apiUrl}users/${this.context.user_info.entity_uuid}/getBillingPortalUrl`, {}, { params });
        
        if (billing_portal_url_response.data.billing_portal_url) {
            window.location.href = billing_portal_url_response.data.billing_portal_url;
            return;
        } else {
            console.error("ERROR - could not get billing portal url");
        }
        
        this.setState({
            pageLoader: false
        });
    }

    render() {
        const { socialAccountLoader,pageLoader, imgLoader,coverImgLoader, redirect, cityArr,
            accountInfoLoader, accountDesigInfoLoader, accountPasswordLoader,filteredTotalFavItems,linkedin,twitter,facebook } = this.state;
        if (redirect) {
            window.localStorage.setItem('loginOrigin',this.props.location.pathname);
            return <Redirect to={local_routes.login} />;
        }                                                                  
        else
            if (pageLoader) {
                return (
                    <FullPageSpinner />
                )
            }
            else {
                return (
                    <React.Fragment>
                        <Helmet>
                            <title>PechaKucha Account Settings</title>
                            <meta name="robots" content="noindex" />
                        </Helmet>
                        {pageLoader === true ? <FullPageSpinner /> : null}
                        <div>
                            <Container>
                                <Row className="pad30">
                                    <Col sm={12} md={12} lg={6}>
                                        <Form
                                            noValidate
                                            validated={this.state.validatedUserInfo}
                                            onSubmit={this.handleSubmitUserData}
                                        >
                                            <div className="account-border">
                                                <div className="account-head">
                                                    <h6 className="title-account">Account information</h6>
                                                    {/* <p>Lorem ipsum dolor sit amet, consecutetur adipiscing</p> */}
                                                </div>
                                                <div className="account-details">

                                                    <Form.Row>
                                                        <Form.Group as={Col} md="6" controlId="firstName">
                                                            <Form.Label className="pad-r5">First Name</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="First Name"
                                                                value={this.state.firstName}
                                                                onChange={this.myUserInformationHandler}
                                                            />

                                                        </Form.Group>
                                                        <Form.Group as={Col} md="6" controlId="lastName">
                                                            <Form.Label className="pad-r5">Last Name</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Last Name"
                                                                value={this.state.lastName}
                                                                onChange={this.myUserInformationHandler}
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                        <Form.Row>
                                                            <Form.Group as={Col} md="12" controlId="friendly_url">
                                                                <Form.Label className="pad-r5">Friendly Url</Form.Label>
                                                                <Form.Control
                                                                    required
                                                                    type="text"
                                                                    placeholder="Friendly Url"
                                                                    value={this.state.friendly_url}
                                                                    onChange={this.myUserInformationHandler}
                                                                />
                                                            </Form.Group>
                                                        </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} md="12" controlId="userEmail">
                                                            <Form.Label className="pad-r5">Email address</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="email"
                                                                placeholder="Email Address"
                                                                value={this.state.userEmail}
                                                                onChange={this.myUserInformationHandler}
                                                            />

                                                        </Form.Group>

                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} md="12">
                                                            <div className="nearest-city">
                                                                <h6 className="title-account">Nearest PK City</h6>
                                                                <span onClick={() => this.findMyLocation()} className="start-city">Find Nearest City</span>
                                                            </div>
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="6" controlId="userCountry">
                                                            <div className="city-Dropdown">
                                                                <Form.Label>Country</Form.Label>
                                                                <Form.Control
                                                                    as="select"
                                                                    required
                                                                    className="country-data"
                                                                    value={this.state.country}
                                                                    onChange={this.countryCityFilter}
                                                                >
                                                                    {
                                                                        countryArr.map((country) =>
                                                                            <option key={country}>{country}</option>
                                                                        )
                                                                    }
                                                                </Form.Control>
                                                            </div>
                                                        </Form.Group>

                                                        <Form.Group as={Col} md="6" controlId="userCity">
                                                            <div className="city-Dropdown">
                                                                <Form.Label>CITY</Form.Label>
                                                                <Form.Control
                                                                    placeholder="None"
                                                                    as="select"
                                                                    required
                                                                    value={this.state.city}
                                                                    onChange={this.countryCityFilter}
                                                                >
                                                                    {cityArr.map(item => (
                                                                        <option key={item}>{item}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </div>
                                                        </Form.Group>
                                                        <span>Don't see a city close to you? <a href="/hostevent" className="start-city">Start one!</a></span>
                                                    </Form.Row>
                                                </div>
                                                <div className="btn-pad">
                                                    {
                                                        accountInfoLoader === false ?
                                                            <PKButton theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 account-btn">
                                                                Save Account Information
                                                        </PKButton>
                                                            :
                                                            <ActivityIndicator theme="button-Status-Loader button-Loader" />
                                                    }
                                                </div>
                                            </div>
                                        </Form>
                                        <Form
                                            noValidate
                                            // validated={this.state.validatedUserDetails}
                                            onSubmit={this.handleSubmitUserDesignationData}
                                        >
                                            <div className="profile-border">
                                                <div className="account-head">
                                                    <h6 className="title-account">Profile information</h6>
                                                    {/* <p>Lorem ipsum dolor sit amet, consecutetur adipiscingLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p> */}
                                                </div>
                                                <div className="account-details emailCheckBox">

                                                    <Form.Row>
                                                        <Form.Group as={Col} md="6" controlId="occupation">
                                                            <Form.Label className="pad-r5">Occupation</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Occupation"
                                                                value={this.state.occupation}
                                                                onChange={this.myUserDataChangeHandler}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="6" controlId="employer">
                                                            <Form.Label className="pad-r5">Employer</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="Employer"
                                                                value={this.state.employer}
                                                                onChange={this.myUserDataChangeHandler}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="12" controlId="userUrl">
                                                            <Form.Label className="pad-r5">Website</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                placeholder="https://"
                                                                value={this.state.website}
                                                                onChange={this.myUserDataChangeHandler}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="12" controlId="description">
                                                            <Form.Label className="pad-r5">Description</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                title={'Description'}
                                                                value={this.state.description}
                                                                rows={4}
                                                                onChange={this.myUserDataChangeHandler}
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    {/* <h6 className="title-account">Notifications</h6> */}
                                                    <Form.Group data-tip="Get notified when you are invited to an event, when presentations are shared with you, etc." as={Col} md="12" controlId="checkbox" className="notificationCheck">
                                                        <Form.Check
                                                            type="checkbox"
                                                            name="email_notifications_status"
                                                            id="email_notifications_status"
                                                            label="Your Presentation / Event Email Notifications"
                                                            className="label-value email-labelpad"
                                                            checked={this.state.user_info.email_notifications_status === 'all' ? true : false}
                                                            onChange={this.handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group data-tip="Stay informed about global PechaKucha News and Events" as={Col} md="12" controlId="checkbox" className="notificationCheck">
                                                        <Form.Check
                                                            type="checkbox"
                                                            //name="email"
                                                            name="email_optin_status"
                                                            id="email_optin_status"
                                                            label="PechaKucha Global Email Notifications"
                                                            className="label-value email-labelpad"
                                                            //checked={this.state.emailNotifications}
                                                            checked={this.state.user_info.email_optin_status === 2 ? true : false}
                                                            onChange={this.handleChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group
                                                        data-tip="Get personalized updates and reminders from PechaKucha.com"
                                                        as={Col}
                                                        md="12"
                                                        controlId="checkbox"
                                                        className="notificationCheck"
                                                        style={{ paddingLeft: "25px" }}
                                                    >
                                                        <Form.Check
                                                            type="checkbox"
                                                            name="email_scheduled_optin_status"
                                                            id="email_scheduled_optin_status"
                                                            label="Personalized Content, Reminders and Update Email Notifications"
                                                            className="label-value email-labelpad"
                                                            checked={this.state.user_info.email_scheduled_optin_status === 'all' ? true : false}
                                                            onChange={this.handleChange}
                                                            disabled={this.state.user_info.email_optin_status === 3}
                                                        />
                                                    </Form.Group>
                                                    {(this.state.org_data.length > 0 || user_account_level === "private") &&
                                                            <Form.Group as={Col} md="12" controlId="public_status_checkbox" className="notificationCheck">
                                                                <Form.Check type="checkbox" name="public_status" label="Public Profile" className="label-value email-labelpad"
                                                                    checked={this.state.public_status_bool}
                                                                    onChange={this.handlePublicStatusChange}
                                                                />
                                                            </Form.Group>
                                                    }
                                                    <ReactTooltip/>
                                                </div>
                                                <div className="btn-pad">
                                                    {
                                                        accountDesigInfoLoader === false ?
                                                            <PKButton theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 account-btn">
                                                                Save Profile Information</PKButton>
                                                            :
                                                            <ActivityIndicator theme="button-Status-Loader button-Loader" />
                                                    }
                                                </div>
                                            </div>
                                        </Form>
                                            <div className="profile-border">
                                                <div className="account-head editFavorite">
                                                    <h6 className="title-account">My Favorites</h6>
                                                    {/* Modal section */}
                                                    <div className="modal-content-custom">
                                                        <FollowControlModalButton/>
                                                    </div>
                          
                                                </div>
                                            </div>
                                            <div className="profile-border">
                                                <div className="account-head">
                                                  
                                                    <h6 className="title-account">My Event Registrations</h6>
                                                  
                                                    { this.state.event_registrant_array.map( (element,index) => 
                                                      <Row key={index}>
                                                        <Col>
                                                          <Link
                                                            to={`${local_routes.events}/${element.friendly_url}`}
                                                          >
                                                            {element.entity_name}
                                                          </Link>
                                                        </Col>
                                                        <Col xs={2}>
                                                          {new Date(element.start_time * 1000).toLocaleDateString()}
                                                        </Col>
                                                      </Row>
                                                    )}
                                                </div>
                                            </div>

                                    </Col>
                                    <Col sm={12} md={12} lg={6}>
                                        <div className="profile-border">
                                            <div className="personal-details coverImageData">
                                                <div className="coverProfile">
                                                    
                                                    <div className="upload-file-container-text d-block">
                                                    
                                                        <fieldset>
                                                            <div className="input-file-row-1 coverImgData">
                                                                <div className="upload-file-cover">
                                                                    {
                                                                        (this.state.coverImagePreviewUrl !== null)
                                                                            ?
                                                                            <img id="preview_image" src={this.state.coverImagePreviewUrl} alt="profile-img" />
                                                                            :
                                                                            (this.state.cover_image_url !== undefined && !null)
                                                                                ?
                                                                                <div>
                                                                                    <img id="preview_image" src={this.state.cover_image_url} alt="profile-img" />
                                                                                    <div style={{ display: this.state.InvalidImageUrl === 0 ? "none" : null }} className="Invalid-section">
                                                                                        <span className="Invalid-Msg">Image Not Uploded</span>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <img id="preview_image" src={avatar} alt="profile-img" />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </fieldset>
                                                        <div className='one_opacity_0'>
                                                            <input 
                                                                type="file" 
                                                                label="add"
                                                                id="myInput"
                                                                ref={(ref) => this.uploadCover = ref}
                                                                style={{ display: 'none' }}
                                                                onChange={this.onChangeCoverFile.bind(this)}
                                                            />
                                                            
                                                        </div>
                                                        
                                                        {
                                                            coverImgLoader === false ?
                                                                <span
                                                                    className="coverUploadImage"
                                                                    label="Open File"
                                                                    //primary={false}
                                                                    onClick={() => { this.uploadCover.click() }}
                                                                    data-tip='Wide (4:1 ratio) recommended'
                                                                >
                                                                    Update Profile Banner Image
                                                                </span>
                                                                :
                                                                <ActivityIndicator theme="button-Status-Loader button-coverLoader" />
                                                        }
                                                        
                                                    </div>
                                                    
                                                </div>

                                            <div className="personal-details">
                                                <div>
                                                    <fieldset>
                                                        <div className="input-file-row-1">
                                                            <div className="upload-file-container">
                                                                {
                                                                    (this.state.imagePreviewUrl !== null)
                                                                        ?
                                                                        <img id="preview_image" src={this.state.imagePreviewUrl} alt="" />
                                                                        :
                                                                        (this.state.avatar_image_url !== null)
                                                                            ?
                                                                            <div>
                                                                                <img id="preview_image" src={this.state.avatar_image_url} alt="" />
                                                                                <div style={{ display: this.state.InvalidImageUrl === 0 ? "none" : null }} className="Invalid-section">
                                                                                    <span className="Invalid-Msg">Image Not Uploded</span>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <img id="preview_image" src={avatar} alt="" />

                                                                }

                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                    
                                                </div>
                                                <div className="personal-info">
                                                    <h5>{this.state.firstName}&nbsp;{this.state.lastName}</h5>
                                                    <p>{this.state.userEmail}</p>
                                                    <div className="upload-file-container-text">
                                                        <div className='one_opacity_0'>
                                                            <input 
                                                                type="file"
                                                                label="add"
                                                                id="myInput"
                                                                ref={(ref) => this.upload = ref}
                                                                style={{ display: 'none' }}
                                                                onChange={this.onChangeFile.bind(this)} multiple 
                                                               />
                                                        </div>
                                                        {
                                                            imgLoader === false ?
                                                                <React.Fragment>
                                                                <span
                                                                    label="Open File"
                                                                    //primary={false}
                                                                    onClick={() => { this.upload.click() }}
                                                                >
                                                                    Update Profile Avatar Image
                                                                </span>
                                                                
                                                                </React.Fragment>
                                                                :
                                                                <ActivityIndicator theme="button-Status-Loader button-Loader" />
                                                        }
                                                        
                                                    </div>
                                                    <span style={{ fontStyle: 'italic', fontSize: 'smaller' }}>Square images work best, with your face in the center</span>
                                                </div>
                                                </div>
                                            </div>
                                            <Form
                                                noValidate
                                                validated={this.state.validatedPassword}
                                                onSubmit={this.handleSubmitData}
                                            >
                                                <div className="pwd-details">
                                                  
                                                    { this.state.stripe_plan_text &&
                                                        <div className="account-head">
                                                            <h6 className="title-account">Account Subscription Type: {this.state.stripe_subscription_type_text}</h6>
                                                            { this.state.stripe_plan_text &&
                                                                <span style={{ marginRight: "20px" }}>{this.state.stripe_plan_text}<br/></span>
                                                            }
                                                            { this.state.stripe_paid_through_time_text &&
                                                                <span style={{ fontSize: "smaller" }}>{this.state.stripe_paid_through_time_text}<br/></span>
                                                            }
                                                            { this.state.stripe_customer_id ? 
                                                              <Button
                                                                  type="button"
                                                                  onClick={this.manageAccountSubscriptionClick}
                                                                  variant="pkprimary"
                                                              >
                                                                  Manage Account Subscription
                                                              </Button>
                                                              :
                                                              <span style={{ fontSize: "smaller", fontStyle: "italic" }}>Please contact PechaKucha Support to manage your subscription</span>
                                                            }
                                                        </div>
                                                    }
                                                    { (this.state.user_info.access_level === 'admin') &&
                                                        <div className="account-head">
                                                            <h6 className="title-account">PK Create PRO Tip Account Status: {this.state.stripe_account_tip_ready_text}</h6>
                                                            { this.state.user_info.stripe_account_tip_ready &&
                                                                <span style={{ marginRight: "20px" }}>Total Tips Received: {(this.state.stripe_account_tip_payout_total / 100).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits: 0, maximumFractionDigits: 2})}<br/></span>
                                                            }
                                                            <Button
                                                              type="button"
                                                              onClick={this.manageStripeTipAccountClick}
                                                              variant="pkprimary"
                                                            >
                                                              Manage Tip Account
                                                            </Button>
                                                        </div>                                                    
                                                    }
                                                    { (this.state.user_info.access_level === 'admin') &&
                                                      <div className="account-head">
                                                        <h6 className="title-account">Creator Tips</h6>
                                                        <TipHistoryModalButton
                                                          tab_choice={this.state.user_info.stripe_account_tip_ready ? 'audience' : 'users.audience'}
                                                        />
                                                      </div>
                                                    }
                                                    {this.state.org_data && this.state.org_data.map((data) =>
                                                        <div key={data.entity_uuid} className="account-head">
                                                            <h6 className="title-account">Member of {data.entity_name} Workspace</h6>
                                                        </div>
                                                    )
                                                    }
                                                    { this.state.facebook_displayName &&
                                                    <div className="account-head">
                                                        <h6 className="title-account">Linked Facebook Login Account</h6>
                                                        <span>{this.state.facebook_displayName}</span>
                                                    </div>
                                                    }
                                                    { this.state.twitter_displayName &&
                                                    <div className="account-head">
                                                        <h6 className="title-account">Linked Twitter Login Account</h6>
                                                        <span>{this.state.twitter_displayName}</span>
                                                    </div>
                                                    }
                                                    { this.state.linkedin_displayName &&
                                                    <div className="account-head">
                                                        <h6 className="title-account">Linked LinkedIn Login Account</h6>
                                                        <span>{this.state.linkedin_displayName}</span>
                                                    </div>
                                                    }
                                                    { this.state.google_displayName &&
                                                    <div className="account-head">
                                                        <h6 className="title-account">Linked Google Login Account</h6>
                                                        <span>{this.state.google_displayName}</span>
                                                    </div>
                                                    }
                                                    <div className="account-head">
                                                        <h6 className="title-account">Change Password</h6>
                                                        <div className="padtop15">
                                                            <Form.Row>
                                                                {this.state.has_password &&
                                                                <Form.Group as={Col} md="12" controlId="oldPasswordName">
                                                                    <Form.Label className="pad-r5">Current Password</Form.Label>
                                                                    <Form.Control
                                                                        required
                                                                        type={this.state.hidden ? "password" : "text"}
                                                                        value={this.state.oldpassword}
                                                                        onChange={this.myPasswordChangeHandler}
                                                                        placeholder="Enter your old password"
                                                                    />
                                                                    <div onClick={this.toggleShow} className="password-show">
                                                                        {this.state.clicked ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}
                                                                    </div>
                                                                </Form.Group>
                                                                }
                                                                <Form.Group as={Col} md="12" controlId="newPasswordName">
                                                                    <Form.Label className="pad-r5">New Password</Form.Label>
                                                                    <Form.Control
                                                                        type={this.state.hiddenNew ? "password" : "text"}
                                                                        value={this.state.newPassword}
                                                                        onChange={this.myPasswordChangeHandler}
                                                                        required
                                                                        placeholder="Enter your new password"
                                                                    />
                                                                    <div onClick={this.toggleShowpassword} className="password-show">
                                                                        {this.state.clickedNew ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}
                                                                    </div>
                                                                </Form.Group>
                                                                <Form.Group as={Col} md="12" controlId="confirmPasswordName">
                                                                    <Form.Label className="pad-r5">Confirm Password</Form.Label>
                                                                    <Form.Control
                                                                        type={this.state.hiddenPassword ? "password" : "text"}
                                                                        value={this.state.confirmPassword}
                                                                        onChange={this.myPasswordChangeHandler}
                                                                        required
                                                                        placeholder="Enter your new password"
                                                                    />
                                                                    <div onClick={this.togglePassword} className="password-show">
                                                                        {this.state.clickedPassword ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}
                                                                    </div>
                                                                </Form.Group>

                                                                {this.state.newPassword === this.state.confirmPassword ? this.messageUpdatePassword() :
                                                                    <div className="InvalidMsgPassword">{this.state.invalidPassword}</div>
                                                                }

                                                            </Form.Row>
                                                            {/* </Form> */}
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="btn-pad">
                                                    {
                                                        accountPasswordLoader === false ?
                                                            <PKButton theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 account-btn">
                                                                Update Password
                                                            </PKButton>
                                                            :
                                                            <ActivityIndicator theme="button-Status-Loader button-Loader" />
                                                    }

                                                </div>
                                            </Form>
                                        </div>
                                        <div className="profile-border">
                                        <Form
                                            noValidate
                                            validated={this.state.validatedSocialAccount}
                                            onSubmit={this.handleSubmitSocialAccount}
                                        >
                                            <div className="pwd-details">
                                                <div className="account-head">
                                                    <h6 className="title-account">Public Social Account Names</h6>
                                                </div>
                                                    <div className="account-details">
                                                            <Form.Row>
                                                                <Form.Group as={Col} md="12" controlId="facebook_handle">
                                                                    <Form.Label className="pad-r5">Facebook</Form.Label>
                                                                    <InputGroup>
                                                                        <InputGroup.Prepend style={{ marginTop: "7px"}}>
                                                                            <InputGroup.Text>https://www.facebook.com/</InputGroup.Text>
                                                                        </InputGroup.Prepend>
                                                                        <Form.Control
                                                                            required
                                                                            type="text"
                                                                            value={facebook}
                                                                            onChange={this.socialAccountHandler}
                                                                        />
                                                                    </InputGroup>
                                                                </Form.Group>
                                                                <Form.Group as={Col} md="12" controlId="twitter_handle">
                                                                    <Form.Label className="pad-r5">Twitter</Form.Label>
                                                                    <InputGroup>
                                                                        <InputGroup.Prepend style={{ marginTop: "7px"}}>
                                                                            <InputGroup.Text>https://twitter.com/</InputGroup.Text>
                                                                        </InputGroup.Prepend>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={twitter}
                                                                            onChange={this.socialAccountHandler}
                                                                            required
                                                                        />
                                                                    </InputGroup>
                                                                </Form.Group>
                                                                <Form.Group as={Col} md="12" controlId="linkedin_handle">
                                                                    <Form.Label className="pad-r5">Linkedin</Form.Label>
                                                                    <InputGroup>
                                                                        <InputGroup.Prepend style={{ marginTop: "7px"}}>
                                                                            <InputGroup.Text>https://www.linkedin.com/in/</InputGroup.Text>
                                                                        </InputGroup.Prepend>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={linkedin}
                                                                            onChange={this.socialAccountHandler}
                                                                            required
                                                                        />
                                                                    </InputGroup>
                                                                </Form.Group>
                                                            </Form.Row>
                                                        </div>
                                                    </div>
                                                    {/* </div> */}
                                                
                                                <div className="btn-pad">
                                                    {
                                                        socialAccountLoader === false ?
                                                            <PKButton theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 account-btn">
                                                                Save Public Social Account Names
                                                            </PKButton>
                                                            :
                                                            <ActivityIndicator theme="button-Status-Loader button-Loader" />
                                                    }

                                                </div>
                                        </Form>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                            <Footer 
                             homeImg={home}
                             homeImgRef="/" 
                             breadcrumbSubPage="Account Settings"
                             />
                        </div>
                    </React.Fragment>
                );
            }
    }

}
export default AccountSettings;